/*
TRANE CONFIDENTIAL

2017 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/
import AccessCode from "nexia_mobile/models/mixins/device_features/access_code";
import ActionButtons from "nexia_mobile/models/mixins/device_features/action_buttons";
import ActivateLock from "nexia_mobile/models/mixins/device_features/activate_lock";
import AdvancedInfo from "nexia_mobile/models/mixins/device_features/advanced_info";
import Alarm from "nexia_mobile/models/mixins/device_features/alarm";
import Barrier from "nexia_mobile/models/mixins/device_features/barrier";
import Battery from "nexia_mobile/models/mixins/device_features/battery";
import ButtonPad from "nexia_mobile/models/mixins/device_features/button_pad";
import Camera from "nexia_mobile/models/mixins/device_features/camera";
import Colored from "nexia_mobile/models/mixins/device_features/colored";
import Connection from "nexia_mobile/models/mixins/device_features/connection";
import Dimmer from "nexia_mobile/models/mixins/device_features/dimmer";
import DragonflyWifiConfiguration from "nexia_mobile/models/mixins/device_features/dragonfly_wifi_configuration";
import Fan from "nexia_mobile/models/mixins/device_features/fan";
import Group from "nexia_mobile/models/mixins/device_features/group";
import LockLock from "nexia_mobile/models/mixins/device_features/lock_lock";
import Occupancy from "nexia_mobile/models/mixins/device_features/occupancy";
import PanTilt from "nexia_mobile/models/mixins/device_features/pan_tilt";
import Pivot from "nexia_mobile/models/mixins/device_features/pivot";
import PivotOccupancyMode from "nexia_mobile/models/mixins/device_features/pivot_occupancy_mode";
import RoomIq from "nexia_mobile/models/mixins/device_features/room_iq";
import RuntimeHistory from "nexia_mobile/models/mixins/device_features/runtime_history";
import Schedule from "nexia_mobile/models/mixins/device_features/schedule";
import Sensor from "nexia_mobile/models/mixins/device_features/sensor";
import SolarPanel from "nexia_mobile/models/mixins/device_features/solar_panel";
import Speaker from "nexia_mobile/models/mixins/device_features/speaker";
import Sprinkler from "nexia_mobile/models/mixins/device_features/sprinkler";
import Streamable from "nexia_mobile/models/mixins/device_features/streamable";
import Switch from "nexia_mobile/models/mixins/device_features/switch";
import Thermostat from "nexia_mobile/models/mixins/device_features/thermostat";
import ThermostatCompressorSpeed from "nexia_mobile/models/mixins/device_features/thermostat_compressor_speed";
import ThermostatFanMode from "nexia_mobile/models/mixins/device_features/thermostat_fan_mode";
import ThermostatMode from "nexia_mobile/models/mixins/device_features/thermostat_mode";
import ThermostatRunMode from "nexia_mobile/models/mixins/device_features/thermostat_run_mode";
import Unenroll from "nexia_mobile/models/mixins/device_features/unenroll";
import UnlockLock from "nexia_mobile/models/mixins/device_features/unlock_lock";
import Valve from "nexia_mobile/models/mixins/device_features/valve";
import WindowShadeOpenCloseStop from "nexia_mobile/models/mixins/device_features/window_shade_open_close_stop";
import WindowShadeSetPercentOpen from "nexia_mobile/models/mixins/device_features/window_shade_set_percent_open";
import XR724WifiConfiguration from "nexia_mobile/models/mixins/device_features/xr724_wifi_configuration";

export {
  AccessCode,
  ActionButtons,
  ActivateLock,
  AdvancedInfo,
  Alarm,
  Barrier,
  Battery,
  ButtonPad,
  Camera,
  Colored,
  Connection,
  Dimmer,
  DragonflyWifiConfiguration,
  Fan,
  Group,
  LockLock,
  Occupancy,
  PanTilt,
  Pivot,
  PivotOccupancyMode,
  RoomIq,
  RuntimeHistory,
  Schedule,
  Sensor,
  SolarPanel,
  Speaker,
  Sprinkler,
  Streamable,
  Switch,
  Thermostat,
  ThermostatCompressorSpeed,
  ThermostatFanMode,
  ThermostatMode,
  ThermostatRunMode,
  Unenroll,
  UnlockLock,
  Valve,
  WindowShadeOpenCloseStop,
  WindowShadeSetPercentOpen,
  XR724WifiConfiguration,
};



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/index.js